// Which visit each schema filed a fax onto.
//
// A fax that reaches several schemas lands on a DIFFERENT visit in each — the
// patient's next appointment at that clinic — so one date for the whole row
// would be right for one schema and wrong for the rest. The inbox shows them
// side by side, per schema.
//
// A schema that matched only the patients table has no visit to point at. That
// reads "n/a": borrowing a sibling schema's date would claim a visit that does
// not exist there.
import { formatVisitDate } from "./faxReportPath";

export const NO_VISIT = "n/a";

/**
 * The date label for one schema on a fax entry.
 *
 * @param schema the schema being labelled
 * @param fax    the inbox row; reads `matched_dates` ({schema: 'YYYY-MM-DD'})
 */
export function schemaVisitLabel(schema, fax) {
  const iso = (fax?.matched_dates || {})[schema];
  return iso ? formatVisitDate(iso) : NO_VISIT;
}
